
import { defineComponent, ref } from 'vue'
import ModalBase from '@/views/modal/ModalBase.vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import { repositories } from '@/repositories/system/repositories'
import { useRoute } from 'vue-router'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'

const service = repositories.user

export default defineComponent({
  components: {
    ResponseResultAlert,
    LoadingButton,
    ModalBase
  },
  emits: {
    dismiss: () => true,
    send: () => true
  },
  setup (props, { emit }) {
    const route = useRoute()
    const requestError = ref<string | null>(null)
    const isWaiting = ref(false)
    const isResponseSucceed = ref(false)

    const dismiss = () => {
      emit('dismiss')
    }

    const sendWelcomeMail = async () => {
      isWaiting.value = true
      const companyKey = route.params.companyKey as string
      await callApiWrapper(requestError, async () => {
        await service.sendWelcomeAllUser(companyKey)
        isResponseSucceed.value = true
        emit('send')
      })
      isWaiting.value = false
    }

    return {
      requestError,
      isWaiting,
      isResponseSucceed,
      dismiss,
      sendWelcomeMail
    }
  }
})
